import { Flex } from "antd";

import { DonutChart } from "@/components/Elements/Charts";
import { useTranslateCost } from "@/modules/translate";

import ProjectCostLine from "./ProjectCostLine";
import { useProjectsCostsCardData } from "./useProjectsCostsCardData";

// Keep styles in JSX to work with Echart
const chartStyle = { width: "130px", minHeight: "130px" };

const ProjectCostsCardContent = ({ project }) => {
  const { translateCost } = useTranslateCost();

  const {
    interventionsCost,
    interventionsRevisedCost,
    additionalCostsHighlighted,
    additionalCostsOthers,
    estimatedTotalCost,
  } = useProjectsCostsCardData(project);

  const noExistingCosts =
    !interventionsCost &&
    !interventionsRevisedCost &&
    !additionalCostsHighlighted.length &&
    !additionalCostsOthers
      ? true
      : false;

  const chartInterventionsCost = interventionsRevisedCost
    ? interventionsRevisedCost
    : interventionsCost;

  const chartData = [
    ...(chartInterventionsCost ? [chartInterventionsCost] : []),
    ...additionalCostsHighlighted,
    ...(additionalCostsOthers ? [additionalCostsOthers] : []),
  ];

  return (
    <Flex gap="middle" align="center" justify="space-around">
      <div className="project-costs-card-grid">
        {interventionsCost && (
          <ProjectCostLine
            {...interventionsCost}
            textsClassName={
              interventionsRevisedCost ? "disabled-cost" : undefined
            }
          />
        )}
        {interventionsRevisedCost && (
          <ProjectCostLine {...interventionsRevisedCost} />
        )}
        {additionalCostsHighlighted.map((cost) => (
          <ProjectCostLine key={cost.id} {...cost} />
        ))}
        {additionalCostsOthers ? (
          <ProjectCostLine {...additionalCostsOthers} />
        ) : null}
        {noExistingCosts && <div className="line-no-costs">_</div>}
        <hr className="line-separator" />
        <ProjectCostLine textsClassName="total-cost" {...estimatedTotalCost} />
      </div>

      <div style={chartStyle}>
        {!noExistingCosts && (
          <DonutChart
            data={chartData}
            formatTooltipValue={translateCost}
            customOptions={{ series: { radius: ["55%", "85%"] } }}
            style={chartStyle}
            hideLegend
            hideTotal
            hideLabels
          />
        )}
      </div>
    </Flex>
  );
};

export default ProjectCostsCardContent;
